export enum VariationPreferences {
  REPHRASE_OR_TRANSLATE = 'rephraseOrTranslate',
  HEADLINE = 'headlinesType',
  TEXT_LENGTH = 'textLength',
  KEEP_WP_BLOCKS = 'keepWPBlocks',
  TEMPERATURE = 'temperature',
  STRUCTURE = 'structure'
}
